import React from "react";
import "./styles.scss";
import { MobileFloatingButton } from "halifax";
import { Box } from "@material-ui/core";
import { CarBookMobileButtonConnectorProps } from "./container";
import {
  ADD_TRAVELERS,
  ADD_CONTACT_INFO,
  APPLY_REWARDS,
  CONFIRM_AND_BOOK,
} from "./textConstants";

export interface ICarBookMobileButtonProps
  extends CarBookMobileButtonConnectorProps {
  showPaymentStep: boolean;
  hasContactInfo?: boolean;
  isBookingValid: boolean;
  openContactInfo: () => void;
  onApplyRewards: () => void;
  onConfirmAndBook: () => void;
  paymentCardOpen?: boolean;
}

export const CarBookMobileButton = (props: ICarBookMobileButtonProps) => {
  const {
    hasContactInfo,
    selectedTravelerId,
    openContactInfo,
    showPaymentStep,
    onApplyRewards,
    onConfirmAndBook,
    isBookingValid,
    paymentCardOpen,
  } = props;

  const [timeoutPassed, setTimeoutPassed] = React.useState<boolean>(false);

  const getButtonText = () => {
    if (!selectedTravelerId) {
      return ADD_TRAVELERS;
    }
    if (!hasContactInfo) {
      return ADD_CONTACT_INFO;
    }
    if (!showPaymentStep) {
      return APPLY_REWARDS;
    }
    return CONFIRM_AND_BOOK;
  };
  const isDisabled = () => {
    if (showPaymentStep && !isBookingValid) return true;

    return false;
  };
  const onClick = () => {
    if (!hasContactInfo) {
      openContactInfo();
    } else if (!showPaymentStep) {
      onApplyRewards();
    } else {
      onConfirmAndBook();
    }
  };

  React.useEffect(() => {
    // enable button after delay to prevent initial focus state in mobile safari
    if (!paymentCardOpen) {
      setTimeout(() => {
        setTimeoutPassed(true);
      }, 300);
    } else {
      setTimeoutPassed(false);
    }
  }, [paymentCardOpen]);

  if (isDisabled()) return null;

  return (
    <Box className="car-book-mobile-button-container">
      <MobileFloatingButton
        className="car-book-mobile-button"
        onClick={onClick}
        wrapperClassName="b2b"
        disabled={!timeoutPassed}
      >
        {getButtonText()}
      </MobileFloatingButton>
    </Box>
  );
};
